module.exports = __webpack_public_path__ + "img/gobe.992b9865.png";